import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeBlock() {
  return <section className="py-20 md:py-28 bg-cream" data-id="element-63">
      <div className="container mx-auto px-6 max-w-3xl" data-id="element-64">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6
      }} className="relative bg-white rounded-[2rem] border-2 border-salvia/50 px-7 py-10 md:px-14 md:py-14 shadow-sm" data-id="element-65">
          {/* Soft inner glow */}
          <div aria-hidden className="absolute inset-0 rounded-[2rem] bg-gradient-to-b from-olive/40 to-transparent pointer-events-none" data-id="element-66" />

          <div className="relative flex flex-col md:flex-row items-center md:items-start gap-6 md:gap-8 text-center md:text-left" data-id="element-67">
            {/* Seal icon */}
            <div className="shrink-0" data-id="element-68">
              <div className="w-20 h-20 md:w-24 md:h-24 rounded-full bg-[#2D6A4F] text-white flex items-center justify-center shadow-lg shadow-[#2D6A4F]/25 border-4 border-white ring-2 ring-[#2D6A4F]/20" data-id="element-69">
                <ShieldCheck className="w-9 h-9 md:w-11 md:h-11" strokeWidth={2} data-id="element-70" />
              </div>
            </div>

            {/* Copy */}
            <div className="flex-1" data-id="element-71">
              <p className="text-[11px] font-black tracking-[0.25em] uppercase text-salvia mb-2" data-id="element-72">
                Tu compra está protegida
              </p>
              <h3 className="font-serif text-2xl md:text-3xl font-semibold tracking-tight text-forest leading-[1.15] mb-4" data-id="element-73">
                Garantía de Bienestar de 7 días
              </h3>
              <p className="text-[15px] md:text-base text-forest/75 leading-relaxed" data-id="element-74">
                Prueba el protocolo. Si en 7 días no sientes una mejora real en
                tu digestión, te devolvemos el dinero. Sin preguntas. Queremos
                que tu cambio sea real.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}